module.exports = __webpack_public_path__ + "img/plus-small.24a01b05.svg";